import { render, staticRenderFns } from "./Leltar.vue?vue&type=template&id=08790485&lang=html&"
import script from "./Leltar.vue?vue&type=script&lang=js&"
export * from "./Leltar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports